import { render } from "./validation.vue?vue&type=template&id=487c6c9c&scoped=true"
import script from "./validation.vue?vue&type=script&lang=js"
export * from "./validation.vue?vue&type=script&lang=js"

import "./validation.vue?vue&type=style&index=0&id=487c6c9c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-487c6c9c"]])

export default __exports__